// @flow
import { useEffect, useState, useRef } from 'react';
import styled from '@emotion/styled';
import Select from '@tablekit/select';
import { SPACING } from '@tablekit/theme';
import { Z_INDICES } from 'utils/theme';
import { ShopListGrid as CoreGrid, gridElementStyles } from './styled';

type OptionsType = { label: string, value: string }[];

type PropsType = {
  areaOptions: OptionsType,
  areasLabel?: string,
  filterShops: (selectedAreas: string[], selectedTags: string[]) => void,
  tagOptions: OptionsType,
  tagsLabel?: string
};

const FilterSelect = styled(Select)`
  ${gridElementStyles};
  z-index: ${({ position }) => Z_INDICES.MAX_CONTENT - position};
  margin-bottom: ${SPACING.L4};
`;

const FiltersGrid = styled(CoreGrid)`
  margin-bottom: ${SPACING.L4} !important;
`;

export const MAX_FILTERS = 3;

function updateFromSelect(selectedOptions, setState) {
  if (!selectedOptions) {
    setState([]);
    return;
  }
  let selectedOptionsArray = selectedOptions;
  if (typeof selectedOptionsArray.length === 'undefined') {
    selectedOptionsArray = [selectedOptions];
  }
  setState(selectedOptionsArray.map(({ value }) => value));
}

const Filters = ({
  areasLabel,
  tagsLabel,
  areaOptions,
  tagOptions,
  filterShops
}: PropsType) => {
  const [selectedAreas, setSelectedAreas] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  const isUpdateRef = useRef(false);
  useEffect(() => {
    // this skips the initial render and only calls filter shops when the dependent
    // states change
    if (isUpdateRef.current) {
      filterShops(selectedAreas, selectedTags);
    } else {
      isUpdateRef.current = true;
    }
  }, [selectedAreas, selectedTags]);

  const filters = [];
  if (areaOptions.length && areasLabel) {
    filters.push(
      <FilterSelect
        key="area"
        position={1}
        options={areaOptions}
        isClearable
        placeholder={areasLabel}
        onChange={(selectedOption) =>
          updateFromSelect(selectedOption, setSelectedAreas)
        }
      />
    );
  }
  if (tagOptions.length && tagsLabel) {
    filters.push(
      <FilterSelect
        key="tags"
        position={filters.length + 1}
        options={tagOptions}
        isClearable
        placeholder={tagsLabel}
        onChange={(selectedOption) =>
          updateFromSelect(selectedOption, setSelectedTags)
        }
      />
    );
  }

  if (!filters.length) return null;

  return <FiltersGrid>{filters}</FiltersGrid>;
};

export default Filters;
